import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import axios from "axios";
import { getToken } from "./services/auth";

// Set axios default Authorization header if token exists
const token = getToken();
if (token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

// Some older views call fetch directly. Attach the ID token only for our API.
const nativeFetch = window.fetch.bind(window);
window.fetch = (input, options = {}) => {
  const apiOrigin = new URL(process.env.REACT_APP_API_BASE_URL, window.location.href).origin;
  const requestUrl = new URL(input instanceof Request ? input.url : String(input), window.location.href);
  const currentToken = getToken();
  if (requestUrl.origin !== apiOrigin || !currentToken) return nativeFetch(input, options);
  const headers = new Headers(options.headers || (input instanceof Request ? input.headers : undefined));
  if (!headers.has("Authorization")) headers.set("Authorization", `Bearer ${currentToken}`);
  return nativeFetch(input, { ...options, headers });
};

axios.interceptors.request.use((config) => {
  const currentToken = getToken();
  if (currentToken && !config.headers?.Authorization) config.headers.Authorization = `Bearer ${currentToken}`;
  return config;
});

axios.interceptors.response.use((response) => response, (error) => {
  if (String(error.config?.method || "").toLowerCase() === "get") window.dispatchEvent(new CustomEvent("view-load-error", { detail: error.response?.data?.error || "An error occurred while loading this view." }));
  return Promise.reject(error);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
const enableStrictMode =
  String(process.env.REACT_APP_ENABLE_STRICT_MODE).toLowerCase() === "true";

root.render(
  enableStrictMode ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
